module.exports = {
    search: {
        externalRedirectionDelay: 0,
        searchSuggestionThrottleTimeout: undefined,
        zeroSearchResultsMessage: 'Your search term "{search}" returns no results',
        shouldRememberSort: false,
        categoryFilterName: 'Category',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/search.js